<template>
  <div v-if="loading" class="loader" v-bind:class="overlayClass">
    <div class="content" v-bind:class="classContent">
      <pulse-loader :loading="loading" :color="color" :size="size" v-bind:style="loaderStyle"/>
      <span v-if="label" class="label">{{ label }}</span>
    </div>
  </div>
</template>

<script>
  import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

  export default {
    props: {
      loading: {
        type: Boolean,
        default: true
      },
      size: {
        type: String,
        default: '20px'
      },
      color: {
        type: String,
        default: '#1DC7EA'
      },
      label: {
        type: String,
        required: false
      },
      overlay: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        loaderStyle: {
          height: this.size
        }
      }
    },
    computed: {
      classContent () {
        return {
          'withLabel': this.label,
          'withoutLabel': !this.label,
          'overlay': this.overlay
        }
      },
      overlayClass () {
        return {
          'overlay': this.overlay
        }
      }
    },
    components: {
      PulseLoader
    }
  }
</script>

<style lang="sass" scoped>
  .content
    width: 100%
    margin: auto
    height: 40px
    text-align: center
    position: absolute
    bottom: 0

    &:not(.overlay)
      left: 0
      right: 0
      margin-bottom: 20px

    &.overlay
      top: 0
      bottom: 0

  .withoutLabel
    height: 22px

  .v-spinner
    width: 90px
    margin: auto
    display: block
    vertical-align: middle

  .label
    display: block
    vertical-align: middle
    font-size: 13px
    font-weight: bold
    opacity: 0.5
    line-height: 28px

  div.loader
    display: block
    width: 100%

    &.overlay
      top: 0
      left: 0
      height: 100%
      position: absolute
      background: rgba(250, 250, 250, 0.8)
      z-index: 2147483646
</style>



// WEBPACK FOOTER //
// Loader.vue?ee88f0dc